
import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import "../../../assets/css/BlessLanding.css";
import logo from "../../../assets/images/bless.png";

const BlessLandingPage = () => {
  return (
    <div className="bless-landing-page">
      {/* Header */}
      <header className="bless-header">
        {/* Logo */}
        <div className="bless-logo">
          <Link to="/">
          <img src={logo} alt="B'Less Logo" />
          </Link>
        </div>

        {/* Navigation */}
        <nav className="bless-nav">
          <div className="separator" style={{ backgroundColor: "#e18586" }} />
          <ul>
            <li>
              <Link to="/">Home</Link> {/* Use Link instead of <a> */}
            </li>
            <li>
              <Link to="/bless/collections">Collection</Link>
            </li>
            <li>
            <a href="#bcontact">Contact Us</a>
            </li>
          </ul>
          <div className="separator" style={{ backgroundColor: "#e18586" }} />
        </nav>
      </header>
      {/* Main Content */}
      <section className="bless-main">
        {/* Text Section */}
        <div className="bless-text-container">
          <p>
            Introducing B'Less—a revolutionary braless apparel line for women
            who crave true freedom. Say goodbye to discomfort and hello to
            effortless style and liberation. Designed for both lounging and
            stepping out, B'Less moves with you, offering unmatched comfort and confidence.
          </p>
        </div>
      </section>
    </div>
  );
};

export default BlessLandingPage;